module.exports = __webpack_public_path__ + "img/bespoke70_14.689fb62e.jpg";